module.exports = __webpack_public_path__ + "./Nao_4a378f63787da2426ff6a5b4b0c2af95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Nao.jpg
// module id = 572
// module chunks = 0